import React from "react";
import Text from "../../../../library/text";

import "./style.scss";

const Index = () => {
  return (
    <div className="single-list-description-container">
      <Text>
        Nedenfor finner du en liste over alle bedriftene som er i listen din. Du
        kan trykke på hver enkelt bedrift for å se mer detaljert informasjon.
      </Text>
    </div>
  );
};

export default Index;
